import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HomeView2 from '../views/HomeView2.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/home',
    name: 'homeb',
    component: HomeView2
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/carte',
    name: 'carte',
    component: () => import('../views/Carte.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  },

  {
    path: '/informations',
    name: 'informations',
    component: () => import('../views/Informations.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router